module.exports = __webpack_public_path__ + "img/bj50.91d3a6c5.png";